const defaultState = {
  requesting: false,
  error: false,
  result: null,
  isCreate: false
};

export default function counter(state = defaultState, action) {
  switch (action.type) {
    case 'FETCH_LOGGED_IN_USERS_REQUESTED':
      return {
        requesting: true,
        error: false,
        result: null,
        isCreate: false
      }
    case 'FETCH_LOGGED_IN_USERS_SUCCEEDED':
      return {
        requesting: false,
        error: false,
        result: action.payload,
        isCreate: false
      }
    case 'FETCH_LOGGED_IN_USERS_FAILED':
      return {
        requesting: false,
        error: true,
        result: action.payload,
        isCreate: false
      }
    default:
      return state
  }
}
